import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { initDone as initDoneSelector } from 'ggApp/modules/init/selectors';
import { compose, branch, renderNothing } from 'recompose';
import { initAnalytics, enrichAnalyticsUser } from '@devsbb/analytics-client';
import CookiesManager from 'ggApp/utils/CookiesManager';
import { haveFeatureFlagsChanged, hasUserIdChanged } from 'analytics/utils';

import { flagsDataForEventTracking as flagsDataForEventTrackingSelector } from 'ggApp/modules/featureFlag';

import { canUseDOM } from 'ggApp/utils/dom';
import loadConfiguration from 'ggApp/utils/configuration/configuration';
import { loadSnowplow } from '../../utils';
import { initializeSnowplow, initializePageViewTracking } from '../../api';

const { SEGMENT_WRITE_KEY } = loadConfiguration();

// TODO: @analytics Remove snowplow, move analytics to own folder
initAnalytics({ segmentWriteKey: SEGMENT_WRITE_KEY }).catch(() =>
    console.warn('Analytics failed to load.'),
);
class SnowplowLoader extends React.Component {
    constructor(props) {
        super(props);

        if (!canUseDOM()) {
            return;
        }

        initializeSnowplow();
        loadSnowplow().catch(() => console.warn('Snowplow was not loaded.'));

        const cookiesManager = new CookiesManager();
        const userId = cookiesManager.get('user_id');

        // Prevent extra enrich calls by first checking user_id against a cached version used by the analytics library
        if (userId && hasUserIdChanged(userId)) {
            enrichAnalyticsUser({ id: userId });
        }
    }

    componentDidMount() {
        const { featureFlags } = this.props;

        const mappedFeatureFlags = Object.keys(featureFlags).reduce(
            (flags, flag) => ({
                ...flags,
                [flag]: featureFlags[flag].variantKey,
            }),
            {},
        );

        // Prevent extra enrich calls by first checking featureFlags against a cached version
        if (haveFeatureFlagsChanged(mappedFeatureFlags)) {
            enrichAnalyticsUser({ featureFlags: mappedFeatureFlags });
        }
        initializePageViewTracking({ featureFlags });
    }

    render() {
        return null;
    }
}

const enhanced = compose(
    connect(
        createStructuredSelector({
            featureFlags: flagsDataForEventTrackingSelector,
            initDone: initDoneSelector,
        }),
    ),
    // initDone – catalog entry
    branch(({ initDone }) => !initDone, renderNothing),
)(SnowplowLoader);

export { enhanced as SnowplowLoader };
